import rtlcss from "rtlcss";
export const STYLIS_PROPERTY_CONTEXT = -1;
const stylisRTLCSS = (context, selector) => {
    if (context === STYLIS_PROPERTY_CONTEXT) {
        return rtlcss.process(selector);
    }
};
Object.defineProperty(stylisRTLCSS, "name", { value: "stylisRTLCSS" });
export default stylisRTLCSS;
//# sourceMappingURL=rtlcss.js.map